// extracted by mini-css-extract-plugin
module.exports = {"Last":"Last_Last__2yO8-"};